import { Button, Card, BlockStack, Text, InlineStack } from '@shopify/polaris'
import { Carousel } from 'antd';
import React, { useState } from 'react'
import getTemplate from '../../../../Asests/Images/get-template.png';
import account from '../../../../Asests/Images/account.png';
import template from '../../../../Asests/Images/template.png';
import listing from '../../../../Asests/Images/listing.png';
import GuideImage from '../../../../Asests/Images/Guide2.png';
import GuideImage2 from '../../../../Asests/Images/guideVideo.png';
import productCategory from '../../../../Asests/Images/product-categories.png';
import '../css/styles.css';
import VideoPlayerModal from './VideoPlayerModal';
import { useTranslation } from 'react-i18next';
interface timeStampI {
    start: string
    end: string
    title: string
}
interface videoDetailsI {
    heading: string
    description: string
    image: any
    url: string
    timeStamp: timeStampI[]
}
const contentStyle: any = {
    carouselProps: {
        slidesToShow: 2,
        dots: false,
        arrows: true,
        draggable: true,
        infinite: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true,
                    dots: false,
                    centerMode: false,
                    centerPadding: "10px",
                },
            },
            {
                breakpoint: 420,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: false,
                    centerPadding: "10px",
                },
            },
        ],
    },
};

const Guide = () => {
    const { t } = useTranslation();
    const [active, setActive] = useState(false);
    const [modalURLandHead, setModalURLandHead] = useState<any>({});
    const videoDetails: videoDetailsI[] = [
        {
            heading: t('How to edit a Single Product on CedCommerce Amazon Channel'),
            description: t("Discover how to modify the details of a single Shopify product to align with Amazon's requirements. Boost your sales potential on Amazon with clear product descriptions that educate potential customers. Watch this video to learn how you can enhance your product descriptions!"),
            image: GuideImage,
            url: "L-sY8sl6coQ",
            timeStamp: [
                {
                    start: '00',
                    end: '10',
                    title: t("Intro")
                },
                {
                    start: '10',
                    end: '20',
                    title: t("Select the product")
                },
                {
                    start: '20',
                    end: '30',
                    title: t("Edit the product")
                },
                {
                    start: '30',
                    end: '52',
                    title: t("Add category & attributes")
                },
                {
                    start: '55',
                    end: '75',
                    title: t("Select & Upload product")
                },
                {
                    start: '75',
                    end: '85',
                    title: t("Outro")
                }
            ]
        },
        {
            heading: t('How to upload multiple products via the CedCommerce Amazon Channel'),
            description: t(" Looking for an easier way to upload your products to Amazon? Our guide is here to help! In this tutorial, you'll learn how to upload multiple products on Amazon from Shopify by creating category templates. Increase visibility to potential customers while saving time. Watch the video now and optimize your approach to uploading products!"),
            image: GuideImage2,
            url: "qs0C951S-tA",
            timeStamp: [
                {
                    start: '00',
                    end: '10',
                    title: t("Intro")
                },
                {
                    start: '10',
                    end: '25',
                    title: t("Add new template")
                },
                {
                    start: '25',
                    end: '32',
                    title: t("Fill in the template details")
                },
                {
                    start: '32',
                    end: '44',
                    title: t("Filter products")
                },
                {
                    start: '55',
                    end: '75',
                    title: t("Upload via template")
                },
                {
                    start: '75',
                    end: '86',
                    title: t("Outro")
                }
            ]
        },
        {
            heading: t('How to link an Existing product via CedCommerce Amazon Channel'),
            description: t("Learn how to link your existing Amazon products to your Shopify inventory with our easy-to-follow guide. This tutorial will help you keep your online store up-to-date by syncing both inventories in near real-time, eliminating the need for manual checking. Watch our tutorial now to discover the key to efficient cross-channel product linking."),
            image: getTemplate,
            url: "7Olft4znKDM",
            timeStamp: [
                {
                    start: '00',
                    end: '12',
                    title: t("Intro")
                },
                {
                    start: '15',
                    end: '42',
                    title: t("Link a Product")
                },
                {
                    start: '42',
                    end: '52',
                    title: t("View Linked Product")
                },
                {
                    start: '52',
                    end: '59',
                    title: t("Outro")
                }
            ]
        },
        {
            heading: t('Order Processing in CedCommerce Amazon Channel app'),
            description: t("Discover the informative video unveiling the effortless order processing capabilities of the CedCommerce Amazon Channel app. Gain insights on centralizing your orders, saving precious time, and efficiently managing both Amazon and Shopify orders for a smoother selling experience."),
            image: getTemplate,
            url: "qnVgG9XmB88",
            timeStamp: [
                {
                    start: '00',
                    end: '18',
                    title: t("Intro")
                },
                {
                    start: '18',
                    end: '46',
                    title: t("Place order on Amazon")
                },
                {
                    start: '46',
                    end: '142',
                    title: t("Manage and fulfill order from amazon")
                },
                {
                    start: '142',
                    end: '154',
                    title: t("Outro")
                }
            ]
        },
        {
            heading: t('Get along with Templates and the way they work'),
            description: t("Templates do matter to sellers who are looking for ways to improve their selling spree. See this video to find out what Templates really do."),
            image: getTemplate,
            url: "nrXODfkG_70",
            timeStamp: [
                {
                    start: '00',
                    end: '08',
                    title: t("Intro")
                },
                {
                    start: '08',
                    end: '45',
                    title: t("What is template")
                },
                {
                    start: '45',
                    end: '120',
                    title: t("Default and Custom template")
                },
                {
                    start: '120',
                    end: '240',
                    title: t("Create custom template")
                },
                {
                    start: '240',
                    end: '277',
                    title: t("Verify Template data on edit page")
                },
                {
                    start: '277',
                    end: '294',
                    title: t("Outro")
                }
            ]
        },
        {
            heading: t('Adding an Amazon account: The Processes'),
            description: t("In case you’re wondering how to add an Amazon account to the CedCommerce Amazon Channel app, here’s a short video that’ll clear your doubts."),
            image: account,
            url: "-C5kG8dqFkM",
            timeStamp: [
                {
                    start: '00',
                    end: '08',
                    title: t("Intro")
                },
                {
                    start: '08',
                    end: '23',
                    title: t("Add new Account")
                },
                {
                    start: '23',
                    end: '38',
                    title: t("Information for having multiple account")
                },
                {
                    start: '38',
                    end: '42',
                    title: t("Outro")
                }
            ]
        },
        {
            heading: t('Assigning Category via Template method'),
            description: t("Here's the way to make the product upload process hassle-free and easy to go! A few simple steps detailed with your go-to video out to walk you through on how you can list your template via Product Level and related information on Amazon via a complete step by step guide! Take a look."),
            image: template,
            url: "p29quKH3TE4",
            timeStamp: [
                {
                    start: '00',
                    end: '07',
                    title: t("Intro")
                },
                {
                    start: '07',
                    end: '86',
                    title: t("Edit product")
                },
                {
                    start: '86',
                    end: '91',
                    title: t("Outro")
                }
            ]
        },
        {
            heading: t('Listings vs Offers: The Dichotomy'),
            description: t("Know the difference between listings and offers? With the CedCommerce Amazon Channel app, sellers can now look for products that are eligible for orders and listings."),
            image: listing,
            url: "vETQqtJCZZY",
            timeStamp: [
                {
                    start: '00',
                    end: '10',
                    title: t("Intro")
                },
                {
                    start: '10',
                    end: '29',
                    title: t("What is Offer and New listing")
                },
                {
                    start: '29',
                    end: '44',
                    title: t("Upload product from app")
                },
                {
                    start: '44',
                    end: '56',
                    title: t("Know your product is elegible for offer selling")
                },
                {
                    start: '56',
                    end: '82',
                    title: t("Know about match from Amazon and Amazon Search")
                },
                {
                    start: '82',
                    end: '90',
                    title: t("Outro")
                }
            ]
        },
        {
            heading: t("Know Product Categories and how to apply them"),
            description: t("Selling has become easier, check out the multiple ways using which Shopify sellers can add/edit categories to the CedCommerce Amazon Channel app."),
            image: productCategory,
            url: "H4qpv98npN0",
            timeStamp: [
                {
                    start: '00',
                    end: '10',
                    title: t("Intro")
                },
                {
                    start: '10',
                    end: '40',
                    title: t("Assign product category")
                },
                {
                    start: '41',
                    end: '62',
                    title: t("Assign product category via template")
                },
                {
                    start: '62',
                    end: '67',
                    title: t("Outro")
                }
            ]
        },
    ]

    const RenderVideos = () => {
        return videoDetails.map((details: any) => {
            return (
                <Card key={details?.url}>
                    <BlockStack gap="500">
                        <img src={details.image} alt={details.heading} />
                        <Text variant='headingMd' as='h2'>{details.heading}</Text>
                        <Text as='span' tone="subdued">{details.description}</Text>
                        <InlineStack align='start'>
                            <Button
                                onClick={() => {
                                    setModalURLandHead(details);
                                    setActive(true);
                                }}>
                                {t("Watch Video")}
                            </Button>
                        </InlineStack>
                    </BlockStack>
                </Card>
            )
        })
    }

    return (
        <Card roundedAbove="sm">
            <BlockStack gap="400">
                <BlockStack gap="300">
                    <Text variant="headingMd" as="h6">{t("App Guide")}</Text>
                    <Text variant="headingMd" as="h6" fontWeight='regular' tone="subdued">{t("Here are a few video tutorials to help you understand best practices for selling products on Amazon with Amazon by CedCommerce App.")}</Text>
                </BlockStack>
                <div className='custom-carousel pricing-carousel overview-carousel'>
                    <Carousel autoplay {...contentStyle.carouselProps} afterChange={onchange}>
                        {RenderVideos()}
                    </Carousel>
                </div>
            </BlockStack>
            <VideoPlayerModal modalURLandHead={modalURLandHead} active={active} setActive={setActive} />
        </Card>
    );
}

export default Guide;